module.exports = __webpack_public_path__ + "static/media/1015714.fb1a7ee0.png";